import { render } from "./Home.vue?vue&type=template&id=23f12884&scoped=true&bindings={\"activeUsers\":\"setup\",\"downloads\":\"setup\",\"avgSessionDuration\":\"setup\",\"paidUsers\":\"setup\",\"cardData\":\"setup\",\"chartData\":\"setup\",\"URL\":\"setup\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=23f12884&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23f12884"

export default script